import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconX16 from '../../../assets/images/Icons/IconX16';
import IconMoveUp16 from '../../../assets/images/Icons/IconMoveUp16';
import IconMoveDown16 from '../../../assets/images/Icons/IconMoveDown16';

const useStyles = makeStyles(
  () => ({
    iconSvg: {
      display: 'block',
    },
    iconContainer: {
      display: 'flex',
      '&>span': {
        cursor: 'pointer',
        margin: '0 0 0 8px',
      },
    },
  }),
  {
    name: 'Icons',
  },
);

function Icons({ index, onDelete, onUp, onDown, messageLength }) {
  const classes = useStyles();

  const isDisabledUp = index === 0;
  const isDisabledDown = index === messageLength - 1;

  return (
    messageLength > 1 && (
      <div className={classes.iconContainer}>
        <span
          style={isDisabledUp ? { pointerEvents: 'none' } : null}
          onClick={() => onUp(index)}
        >
          <IconMoveUp16 className={classes.iconSvg} disabled={isDisabledUp} />
        </span>
        <span
          style={isDisabledDown ? { pointerEvents: 'none' } : null}
          onClick={() => onDown(index)}
        >
          <IconMoveDown16
            className={classes.iconSvg}
            disabled={isDisabledDown}
          />
        </span>
        <span onClick={() => onDelete(index)}>
          <IconX16 className={classes.iconSvg} />
        </span>
      </div>
    )
  );
}

Icons.defaultProps = {
  onDelete: () => {},
  onUp: () => {},
  onDown: () => {},
  messageLength: 0,
  index: -1,
};

Icons.propTypes = {
  onDelete: PropTypes.func,
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  messageLength: PropTypes.number,
  index: PropTypes.number,
};

export default Icons;
